import React from 'react';
import type { JobAd } from '../../../types';

type JobBulletsProps = {
    ad: JobAd;
    className?: string;
};

export function JobBullets(props: JobBulletsProps) {
    const { ad, className = '' } = props;

    if (!(ad.company_name || ad.no_of_positions)) {
        return null;
    }

    return (
        <div className={`text-xs s-text-subtle space-y-2 ${className}`}>
            {ad.company_name && <div>{ad.company_name}</div>}
            {ad.no_of_positions && (
                <div>
                    {ad.no_of_positions +
                        (ad.no_of_positions === 1
                            ? ' stilling'
                            : ' stillinger')}
                </div>
            )}
        </div>
    );
}
